import { twMerge } from 'tailwind-merge';
import NationalTeamColumn from './NationalTeamColumn';
import type { NationalTeamData } from './KnockoutNational.types';

interface KnockoutNationalProps {
  /** Home team data. */
  home: NationalTeamData;
  /** Away team data. */
  away: NationalTeamData;
  /** Localized label for the ranking row (e.g. FIFA ranking), provided by the parent. */
  rankingLabel: string;
  /** Localized label for the missing-players block, provided by the parent. */
  missingPlayersLabel: string;
  /** Optional className for the root wrapper. */
  className?: string;
}

export default function KnockoutNational({
  home,
  away,
  rankingLabel,
  missingPlayersLabel,
  className = '',
}: KnockoutNationalProps) {
  return (
    <div className={twMerge('flex gap-[8px] pb-[8px] px-[16px]', className)}>
      <NationalTeamColumn
        className="flex-1 min-w-0"
        data={home}
        rankingLabel={rankingLabel}
        missingPlayersLabel={missingPlayersLabel}
      />
      <NationalTeamColumn
        className="flex-1 min-w-0"
        data={away}
        rankingLabel={rankingLabel}
        missingPlayersLabel={missingPlayersLabel}
      />
    </div>
  );
}
